import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

var _templateObject, _templateObject2, _templateObject3;

var _excluded = ["status", "text", "disabled", "onClick"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import Done from '@mui/icons-material/Done';
import { Button, buttonClasses, CircularProgress, css, styled } from '@mui/material';
import * as A from 'fp-ts/Array';
import { pipe, unsafeCoerce } from 'fp-ts/function';
import * as R from 'fp-ts/Record';
import * as Semi from 'fp-ts/Semigroup';
import * as Tu from 'fp-ts/Tuple';
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { jsx as _jsx } from "react/jsx-runtime";
export var SaveStates = {
  Saving: 'saving',
  Success: 'success',
  Error: 'error',
  Default: 'default'
};
var defaultButtonConfig = [[SaveStates.Saving, {
  color: 'primary',
  content: 'Saving...'
}], [SaveStates.Success, {
  color: 'success',
  content: 'Saved'
}], [SaveStates.Error, {
  color: 'error',
  content: 'Error'
}], [SaveStates.Default, {
  color: 'primary',
  content: 'Next'
}]];

var createConfig = function createConfig(config) {
  return typeof config === 'string' ? {
    content: config
  } : config;
};

var createTextMap = function createTextMap(text) {
  return pipe(defaultButtonConfig, A.mapWithIndex(function (i, x) {
    return pipe(x, Tu.mapSnd(function (config) {
      return _objectSpread(_objectSpread({}, config), text ? createConfig(text[i]) : {});
    }));
  }), R.fromFoldable(Semi.last(), A.Foldable), function (x) {
    return unsafeCoerce(x);
  });
};

var LoadingButton = /*#__PURE__*/forwardRef(function LoadingButton(_ref, ref) {
  var status = _ref.status,
      text = _ref.text,
      disabled = _ref.disabled,
      _onClick = _ref.onClick,
      props = _objectWithoutProperties(_ref, _excluded);

  var buttonConfig = createTextMap(text);

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
    ref: ref,
    sx: {
      whiteSpace: 'nowrap'
    },
    size: "large",
    color: buttonConfig[status].color,
    variant: "contained",
    disabled: status === 'saving' || status === 'success' || disabled,
    startIcon: status === 'saving' ? /*#__PURE__*/_jsx(CircularProgress, {
      size: 16
    }) : status === 'success' ? /*#__PURE__*/_jsx(Done, {}) : null,
    onClick: function onClick(e) {
      return status !== 'saving' && _onClick && _onClick(e);
    }
  }, props), {}, {
    children: t(buttonConfig[status].content)
  }));
});
export var AsyncButton = styled(LoadingButton)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  &.", " {\n    &:visited {\n      color: ", ";\n    }\n  }\n  &.", ".", " {\n    ", "\n  }\n"])), buttonClasses.contained, function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.primary.contrastText;
}, buttonClasses.contained, buttonClasses.disabled, function (_ref3) {
  var status = _ref3.status,
      theme = _ref3.theme;
  return status === 'success' || status === 'saving' ? css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n            background: ", ";\n            color: ", ";\n            svg {\n              color: ", ";\n            }\n            &:visited {\n              color: ", ";\n            }\n          "])), status === 'success' ? theme.palette.success.main : theme.palette.primary.main, theme.palette.success.contrastText, theme.palette.success.contrastText, theme.palette.success.contrastText) : css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n            color: ", ";\n            svg {\n              color: ", ";\n            }\n            &:visited {\n              color: ", ";\n            }\n          "])), theme.palette.text.disabled, theme.palette.text.disabled, theme.palette.text.disabled);
});